import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom'; // ✅ for HashRouter navigation
import { jwtDecode } from 'jwt-decode';

const MyUserAccount = () => {
    const [user, setUser] = useState(null);
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [imagePreview, setImagePreview] = useState('');
    const fileInputRef = useRef();
    const navigate = useNavigate(); // ✅ use navigate for redirect


    useEffect(() => {
        const token = localStorage.getItem('LGOUser');
        if (token) {
            const decoded = jwtDecode(token);
            if (decoded.myPicture && decoded.myPicture.includes('upload')) {
                decoded.myPicture = `https://www.lgfantasy.ca/Citations/PHP/${decoded.myPicture}`;
            }
            setUser(decoded);
            setPhone(decoded.phone || '');
            setImagePreview(decoded.myPicture || '');
        }
    }, []);

    const handleImageClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (!file || !user?.ID) return;

        const formData = new FormData();
        formData.append('script', 'uploadUserImage');
        formData.append('ID', user.ID);
        formData.append('picture', file);

        const res = await fetch('https://www.lgfantasy.ca/Citations//PHP/userUpdateImage.php', {
            method: 'POST',
            body: formData
        });
        const result = await res.json();
        if (result.status === 'success') {
            const newImageUrl = `https://www.lgfantasy.ca/Citations/PHP/${result.path}`;
            setImagePreview(newImageUrl);
            if (result.token) {
                localStorage.setItem('LGOUser', result.token);
            }
        }

    };

    const handleClearImage = () => {
        setImagePreview('');
    };

    const handleSave = async () => {
        if (!user?.ID) return alert('Missing user ID.');

        const payload = {
            script: 'updateMyUserAccount',
            ID: user.ID,
            phone: phone,
            password: password,
        };

        const res = await fetch('https://www.lgfantasy.ca/Citations/PHP/data.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        const result = await res.json();
        if (result.status === 'success') {
            if (result.token) {
                localStorage.setItem('LGOUser', result.token);
            }
        }

    };

    if (!user) return <div className="p-3 text-center">Loading...</div>;

    const handleLogout = () => {
        localStorage.removeItem('LGOUser');
        navigate("/login"); // ✅ works with HashRouter
    };

    return (
        <div className="container p-4" style={{ maxWidth: 600 }}>
            <h3 className="mb-4 text-center">My Account</h3>

            <div className="text-center mb-4">
                <img
                    src={imagePreview || 'https://www.lgfantasy.ca/Citations/Assets/Male.png'}
                    alt="profile"
                    style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: '50%', cursor: 'pointer' }}
                    onClick={handleImageClick}
                />
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={handleImageChange}
                />
                {/* <div>
                    <button className="btn btn-sm btn-outline-danger mt-2" onClick={handleClearImage}>
                        Reset Image to Icon
                    </button>
                </div> */}
                <div className="text-white fs-7 text-center bg-dark p-2 mt-3">Click User Icon to Update Image</div>
            </div>

            <div className="mb-3">
                <label className="form-label">Display Name</label>
                <input className="form-control" value={user.displayName || ''} disabled />
            </div>

            <div className="mb-3">
                <label className="form-label">Email</label>
                <input className="form-control" value={user.email || ''} disabled />
            </div>

            <div className="mb-3">
                <label className="form-label">Phone</label>
                <input className="form-control" value={phone} onChange={(e) => setPhone(e.target.value)} />
            </div>

            <div className="mb-3">
                <label className="form-label">
                    New Password <span className="text-danger fs-8">(optional)</span>
                </label>
                <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </div>

            <div className="mt-4 text-center gap-2 d-flex justify-content-center">
                <button className="btn btn-success text-light px-4" onClick={handleSave}>
                    Update My Account
                </button>
                <button className="btn btn-danger px-4" onClick={handleLogout}>
                    Log Out
                </button>
            </div>
        </div>
    );
};

export default MyUserAccount;
